const useSEO = ({title, description}) => {
  document.title = title;
  const metaDescription = document.querySelector('meta[name="description"]');

  metaDescription.setAttribute('content', description)

}

export default useSEO;
